import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';

import App from './containers/App/App';
import ReportsApp from './containers/Reports/App';
import DeliveryApp from './containers/Delivery/DeliveryApp';
import AdvertiserApp from './containers/Advertiser/App';
import GoogleBusinessApp from './containers/GoogleBusiness/GoogleBusinessApp';
import asyncComponent from './helpers/AsyncFunc';
import Loader from './components/uielements/loader';

const RestrictedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
const PublicRoutes = ({ history, isLoggedIn, isChangingAdvertiser }) => {
  return (
    <ConnectedRouter history={history}>
      <div>
        <Loader visible={isChangingAdvertiser} text={"Loading advertiser data..."}/>
        <Route
          exact
          path={'/'}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
        <Route
          exact
          path={'/signin'}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
        <Route
          exact
          path={'/logout'}
          component={asyncComponent(() => import('./containers/Page/logout'))}
        />
        <RestrictedRoute
          path="/dashboard"
          component={App}
          isLoggedIn={isLoggedIn}
        />
        <RestrictedRoute
          path="/advertiser"
          component={AdvertiserApp}
          isLoggedIn={isLoggedIn}
        />
        <RestrictedRoute
          path="/leads"
          component={App}
          isLoggedIn={isLoggedIn}
        />
        <RestrictedRoute
          path="/reports"
          component={ReportsApp}
          isLoggedIn={isLoggedIn}
        />
          <RestrictedRoute
              path="/delivery"
              component={DeliveryApp}
              isLoggedIn={isLoggedIn}
          />
          <RestrictedRoute
              path="/google-business"
              component={GoogleBusinessApp}
              isLoggedIn={isLoggedIn}
          />
      </div>
    </ConnectedRouter>
  );
};

export default connect(state => ({
  isLoggedIn: state.Auth.idToken !== null,
  isChangingAdvertiser: state.Advertisers.isChanging,
}))(PublicRoutes);
